import { GET_PROFILE_VERIFICATIONS } from "../../Utils/types";

const initialState = {
  getProfileVerification: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE_VERIFICATIONS:
      return {
        ...state,
        getProfileVerification: action.payload,
      };
    default:
      return state;
  }
};
